/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArticleSummary = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 20h10v2H12zM2 10h8V2H2zm2-6h4v4H4zm8 13h10v2H12zm0-15h10v2H12zm0 6h10v2H12zm0-3h10v2H12zm0 6h10v2H12zm0 3h10v2H12z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgArticleSummary as ArticleSummary };
